import * as React from "react";
import type { SVGProps } from "react";
export const SvgMiscPaperWriting = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 20 20" {...props}>
    <path
      fill="currentColor"
      d="M16.667 18.333H3.333A.833.833 0 0 1 2.5 17.5v-15a.833.833 0 0 1 .833-.833h13.334a.833.833 0 0 1 .833.833v15a.833.833 0 0 1-.833.833Zm-10-12.5V7.5h6.666V5.833H6.667Zm0 3.334v1.666h6.666V9.167H6.667Zm0 3.333v1.667h4.166V12.5H6.667Z"
    />
  </svg>
);
